<template>
  <van-swipe
    class="my-swipe"
    :style="styles"
    :autoplay="config['autoplay'] ? config['autoplay'] : 3000"
    :duration="config['duration'] ? config['duration'] : 500"
    :loop="config['loop'] ? !!Number(config.loop) : true"
    :show-indicators="
      config['show-indicators'] ? !!Number(config['show-indicators']) : true
    "
    :indicator-color="
      config['indicator-color'] ? config['indicator-color'] : '#fff'
    "
    :vertical="config.vertical ? !!Number(config.vertical) : false"
    :ref="`VSwipe_${componentId}`"
  >
    <template v-if="imagesList && imagesList.length">
      <van-swipe-item
        v-for="(item, index) in imagesList"
        :key="item.id"
        :data-index="index"
      >
        <img class="swipe-image" :src="item.url" alt="" :data-index="index" />
      </van-swipe-item>
    </template>

    <template v-else>
      <van-swipe-item>
        <van-empty image="error" description="暂无数据" />
      </van-swipe-item>
    </template>
  </van-swipe>
</template>

<script lang="ts">
export default {
  name: 'VSwipe',
  props: {
    propValue: {
      required: false,
      type: String,
      default: () => {
        return ''
      }
    },
    styles: {
      required: false,
      type: Object,
      default: () => {
        return {}
      }
    },
    componentId: {
      required: true,
      type: [String, Number],
      default: () => {
        return ''
      }
    },
    config: {
      required: false,
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    styles: {
      handler() {
        setTimeout(() => {
          this.$refs[`VSwipe_${this.componentId}`].resize()
        }, 0)
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    imagesList() {
      if (
        this.propValue &&
        this.propValue.split(',') &&
        this.propValue.split(',').length
      ) {
        return this.propValue.split(',').map((item, index) => {
          return {
            url: item,
            id: index
          }
        })
      }
      return []
    }
  }
}
</script>

<style lang="scss" scoped>
.my-swipe {
  width: 100%;
  .swipe-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
